import styles from '@/components/Agents/AgentSessionReadyToast/AgentSessionReadyToast.module.scss';
import { agentDisplayMap } from '@/components/Agents/AgentUtils';
import { _isNotBlank } from '@/littledash';
import { type AgentSessionSettledEventV1 } from '@/model/TeamEvent.model';
import { type FC } from 'react';
import { RiArrowRightLine } from 'react-icons/ri';

interface AgentSessionReadyToastProps {
  event: AgentSessionSettledEventV1;
  onOpen: () => void;
  testId?: string;
}

const statusLabel: Record<AgentSessionSettledEventV1['status'], string> = {
  completed: 'is ready to view',
  awaiting_input: 'needs your input',
  failed: 'failed',
  cancelled: 'stopped before finishing',
};

/**
 * Toast body telling a user an agent run they started has settled, with a one-click way back to
 * the session. Navigation is handed in because toasts render outside the router.
 */
const AgentSessionReadyToast: FC<AgentSessionReadyToastProps> = ({
  event,
  onOpen,
  testId = 'agent-session-ready-toast',
}) => (
  <div
    className="flex flex-column"
    data-test-component="AgentSessionReadyToast"
    data-test-element="container"
    data-testid={testId}
  >
    <div className="mb1" data-test-element="label">
      <strong>
        {agentDisplayMap[event.agent_type].name} {statusLabel[event.status]}
      </strong>
    </div>
    {_isNotBlank(event.study_name) && (
      <div className="f6 dark-gray" data-test-element="study">
        {event.study_name}
      </div>
    )}
    <button type="button" className={styles.open} onClick={onOpen} data-test-element="open-button">
      <RiArrowRightLine />
      Open session
    </button>
  </div>
);

export default AgentSessionReadyToast;
